import React from 'react';
import Sidebar from '../Sidebar/Sidebar';

const Setting = () => {
    return (
        <div className="layoutSidenav dashboard">
            <Sidebar></Sidebar>
            <div className="sidebar_content">
                <h4>Setting</h4>
                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Debitis ducimus exercitationem cumque unde saepe veniam nostrum soluta doloribus consequuntur possimus. Explicabo ad ab soluta impedit veniam quas nobis doloremque earum.</p>
            </div>    
        </div>
    );
};
export default Setting;